var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"logo"},[_c('router-link',{attrs:{"to":{ path: '/', params: {} }}},[_c('img',{attrs:{"src":require("@/assets/images/red_health_logo.svg")}})])],1),_c('div',{staticClass:"menu-icon",on:{"click":_vm.openNav}},[_c('img',{attrs:{"src":require("@/assets/images/menu_icon.svg")}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }